export default __webpack_public_path__ + "static/media/shoulders-incorrect.2ef0fda3.PNG";